import {
  GTM_HTML,
  GTM_URL,
  TOKEN_ID,
  EXPIRY_DAYS,
  GCLID,
  DEVICE_TYPE,
  EVENT_LOAD,
} from '../constants/googleAdConstant';
import { getAffiliateDetails, getMMT_HLD_OBJ } from './appUtils';
import { AFFILIATES } from '../constants/appConstant';
import { isEnableNonEssentialDataPush } from './gdprUtils';
import { getUrlParamsMapV2 } from './browserUtils';

const affiliate = getAffiliateDetails();
const GTM_ID = affiliate.gtmId;

function pushGoogleTagData() {
  if (isEnableNonEssentialDataPush()) {
    dataLayer.push(arguments);
  }
}

export const gtmAddEvents = ({ pageName, eventName, error, branch }) => {
  if (isEnableNonEssentialDataPush()) {
    if ([AFFILIATES.GOIBIBO, AFFILIATES.MMT].includes(affiliate.affiliateIdentifier)) {
      const urlParams = getUrlParamsMapV2();
      window?.dataLayer?.push({
        deviceType: DEVICE_TYPE,
        pageName,
        event: error ? `${pageName}_error` : eventName,
        branch: getMMT_HLD_OBJ()?.branch ? getMMT_HLD_OBJ()?.branch : urlParams?.branch,
      });
    }
  }
};

const loadGlobalSiteTag = (
  pageName,
  { departureCity, travelDate, paxStr, destination, flights } = {}
) => {
  if (isEnableNonEssentialDataPush()) {
    window.dataLayer = window.dataLayer || [];
    pushGoogleTagData('js', new Date());
    pushGoogleTagData('config', GTM_ID);
    addGclId();
    if (pageName) {
      const params = {};

      if (departureCity) {
        params.fromCity = departureCity;
      }

      if (travelDate) {
        params.travelDate = travelDate;
      }

      if (paxStr) {
        params.paxSearched = paxStr;
      }

      if (destination) {
        params.toCity = destination;
      }

      if (flights) {
        params.flights = flights;
      }

      window.dataLayer.push({
        pageName,
        deviceType: DEVICE_TYPE,
        event: `${EVENT_LOAD}_${pageName}`,
        google_tag_params: params,
      });
    }
  }
};

export const globalSiteTag = (
  pageName,
  { departureCity, travelDate, paxStr, destination, flights } = {}
) => {
  if (isEnableNonEssentialDataPush()) {
    if (affiliate.affiliateIdentifier === AFFILIATES.GOIBIBO) {
      loadGlobalSiteTag(pageName, {
        departureCity,
        travelDate,
        paxStr,
        destination,
        flights,
      });
      return;
    }
    const scriptTag = document.createElement('script');
    scriptTag.setAttribute('src', `${GTM_URL}${GTM_ID}`);
    document.head.appendChild(scriptTag);
    scriptTag.addEventListener('load', loadGlobalSiteTag.bind(null, ''));
  }
};

export const orderConversion = (TTV, bookingId, branch) => {
  if (isEnableNonEssentialDataPush()) {
    pushGoogleTagData('event', 'conversion', {
      send_to: `${GTM_ID}/${TOKEN_ID}`,
      value: TTV,
      currency: 'INR',
      transaction_id: bookingId,
      branch,
    });
  }
};

export const getGclId = () => JSON.parse(localStorage.getItem('gclId'));

const getParam = p => {
  const match = RegExp(`[?&]${p}=([^&]*)`).exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

const getExpiryRecord = value => {
  const expiryPeriod = EXPIRY_DAYS * 24 * 60 * 60 * 1000;
  const expiryDate = new Date().getTime() + expiryPeriod;
  return {
    value,
    expiryDate,
  };
};

const setGclId = gclIdParam => {
  let gclIdRecord = null;
  if (gclIdParam) {
    gclIdRecord = getExpiryRecord(gclIdParam);
    localStorage.setItem('gclId', JSON.stringify(gclIdRecord));
  }
};

const addGclId = () => {
  const gclIdParam = getParam(GCLID);
  const gclId = getGclId();
  if (gclIdParam || gclId) {
    if (!gclId) {
      setGclId(gclIdParam);
    } else {
      const gclIdValue = gclId;
      const isGclIdValid = gclIdValue && new Date().getTime() < gclIdValue.expiryDate;
      if (!isGclIdValid) {
        localStorage.removeItem('gclId');
        setGclId(gclIdParam);
      } else if (gclIdValue.value !== gclIdParam && gclIdParam !== null) {
        localStorage.removeItem('gclId');
        setGclId(gclIdParam);
      }
    }
  }
};
